<template>
  <div class="mgx_mode_switch_box" v-if="specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)">
    <div class="mgx_mode_button" :class="{ active: currentMgxMode == MgxMode.IMC }" @click="setIMCSwitch(MgxMode.IMC)">{{ $t('imc_mode_title') }}</div>
    <div class="mgx_mode_button" v-if="!isShowDailyMode" :class="{ active: currentMgxMode == MgxMode.MGX }" @click="setIMCSwitch(MgxMode.MGX)">{{ $t('mgx_axis_mode') }}</div>
    <div class="mgx_mode_button" v-if="isShowDailyMode" :class="{ active: currentMgxMode == MgxMode.Daily }" @click="setIMCSwitch(MgxMode.Daily)">{{ $t('daily_mode') }}</div>
  </div>
</template>

<script setup lang="ts">
import i18n from '@/languages/i18n'
import { enableDialog } from '../cdialog/dialog'
import { computed, onMounted, ref } from 'vue'
import { setOrRead } from '@/service/driver/set_read'
import { SpecificItem } from '@libs/types/enum'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { magnetSet } from '@/service/driver/magnet_set'
import { DeviceManager } from '@/service/device'
const isSwitching = ref(false)

const isShowDailyMode = computed(() => {
  if (isFE87V2IMCNH()) {
    return true
  }
  return false
})

const setIMCSwitch = async (mode: MgxMode) => {
  // if (IMCSwitchState.value && mode == MgxMode.IMC) {
  //   return
  // }
  if (isSwitching.value) {
    return
  }
  currentMgxMode.value = mode

  let setSwitch = false
  if (currentMgxMode.value == MgxMode.IMC) {
    setSwitch = true
  }

  if (setSwitch == IMCSwitchState.value) {
    return
  }
  isSwitching.value = true
  await changeIMCSwitchStatus(setSwitch)
  isSwitching.value = false
  const { t } = i18n.global
  enableDialog(t('setting_success'))
}

onMounted(async () => {
  await fetchIMCSwitchStatus()
})
</script>

<script lang="ts">
export const enum MgxMode {
  None = 0,
  IMC,
  MGX,
  Daily,
}
export const currentMgxMode = ref(MgxMode.MGX)
export const IMCSwitchState = ref(false)
const fetchIMCSwitchStatus = async () => {
  if (!specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)) {
    IMCSwitchState.value = false
    return
  }
  const response = await setOrRead.read<boolean>(SpecificItem.IMCStatus)

  IMCSwitchState.value = response
  if (IMCSwitchState.value) {
    magnetSet.selectedKeys.value = []
  }
}

const changeIMCSwitchStatus = async (state: boolean) => {
  if (!specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)) {
    return
  }
  await setOrRead.write(SpecificItem.IMCStatus, state)
  await fetchIMCSwitchStatus()
}

export const isFE87V2IMCNH = () => {
  if (DeviceManager.instance.state.currentDevice.ProductName && (DeviceManager.instance.state.currentDevice.ProductName.indexOf('C38NH') > -1 || DeviceManager.instance.state.currentDevice.ProductName.indexOf('FeV2I 3824G') > -1)) {
    return true
  }
  return false
}
</script>

<style lang="less" scoped>
.mgx_mode_switch_box {
  display: flex;
  align-items: center;
  background: var(--glass-surface-bg);
  backdrop-filter: blur(var(--glass-surface-blur));
  border-radius: var(--radius-m);
  padding: 4px;
  gap: 4px;

  .mgx_mode_button {
    min-height: 32px;
    min-width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    font-size: 13px;
    font-weight: 600;
    color: var(--color-text-hint);
    cursor: pointer;
    transition: var(--transition-base);
    border-radius: var(--radius-m);
    background: transparent;

    &:hover {
      color: var(--brand-color-pure);
      background: rgba(255, 255, 255, 0.4);
    }

    &.active {
      color: var(--brand-color-pure);
      background: var(--color-white);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      font-weight: 700;
    }
  }
}
</style>
